// ----------------------------------------------------------------------- imports externos
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// ----------------------------------------------------------------------- imports internos
import { qrResponder, qrVer } from "../services/acceso";
import "./css/AprobarQr.css";

/* Lo que ve el celular al escanear el QR de la compu (Igna, 02/11).
 *
 * Pide sesión (está dentro de las rutas privadas): si el celular no estaba
 * logueado, entra primero y vuelve acá. Dice QUÉ equipo lo pidió, y advierte
 * que se apruebe sólo si uno está frente a esa pantalla: un QR que llega por
 * WhatsApp de un desconocido es la forma clásica de robar una sesión. */
const AprobarQr = () => {
  const { token } = useParams();
  const [estado, setEstado] = useState("cargando"); // cargando | pregunta | vencido | aprobado | rechazado | error
  const [dispositivo, setDispositivo] = useState("");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    let vivo = true;
    qrVer(token)
      .then((r) => {
        if (!vivo) return;
        setDispositivo(r?.dispositivo || "");
        setEstado(r?.vigente ? "pregunta" : "vencido");
      })
      .catch(() => vivo && setEstado("error"));
    return () => {
      vivo = false;
    };
  }, [token]);

  const responder = async (aprobar) => {
    setEnviando(true);
    try {
      const r = await qrResponder(token, aprobar);
      setEstado(r?.ok ? (aprobar ? "aprobado" : "rechazado") : "vencido");
    } catch {
      setEstado("error");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="aqr">
      <div className="aqr__tarjeta">
        {estado === "cargando" && <p>Un momento…</p>}

        {estado === "pregunta" && (
          <>
            <h2>¿Entrar al hub en la compu?</h2>
            {dispositivo && (
              <p className="aqr__equipo">
                Lo pidió: <b>{dispositivo}</b>
              </p>
            )}
            <p className="aqr__aviso">
              Aprobá sólo si estás frente a esa pantalla. Si alguien te mandó
              este código, tocá «No fui yo».
            </p>
            <div className="aqr__botones">
              <button
                type="button"
                className="aqr__si"
                onClick={() => responder(true)}
                disabled={enviando}
              >
                Sí, entrar
              </button>
              <button
                type="button"
                className="aqr__no"
                onClick={() => responder(false)}
                disabled={enviando}
              >
                No fui yo
              </button>
            </div>
          </>
        )}

        {estado === "aprobado" && (
          <>
            <h2>Listo</h2>
            <p>La compu ya está entrando. Podés seguir ahí.</p>
          </>
        )}
        {estado === "rechazado" && (
          <>
            <h2>Rechazado</h2>
            <p>La compu no entró.</p>
          </>
        )}
        {estado === "vencido" && (
          <>
            <h2>El código venció</h2>
            <p>Tocá «Mostrar otro código» en la compu y escanealo de nuevo.</p>
          </>
        )}
        {estado === "error" && (
          <>
            <h2>No se pudo consultar</h2>
            <p>Probá escanear el código de nuevo.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AprobarQr;
